import bugsnag from "bugsnag-js";

const bugsnagClient = bugsnag({
  apiKey: "38a4829d096ed2b9f49837b82bc18de5",
  releaseStage: process.env.REACT_APP_ENV.toLowerCase(),
  notifyReleaseStages: ["production", "staging"]
});

export default bugsnagClient;
